// extracted by mini-css-extract-plugin
module.exports = {"customerCard":"customersimplified_customerCard__2Ry4t","selectIcon":"customersimplified_selectIcon__2PYqk","overlay":"customersimplified_overlay__EPvtP"};